import { render } from "./CustomFilterButton.vue?vue&type=template&id=246b7c6a&ts=true"
import script from "./CustomFilterButton.vue?vue&type=script&lang=ts"
export * from "./CustomFilterButton.vue?vue&type=script&lang=ts"

import "./CustomFilterButton.vue?vue&type=style&index=0&id=246b7c6a&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__